
export const LIMIT_PER_PAGE = 20

export const APP_PATH_LOGIN = 'mofang://login'
export const APP_PATH_CLOSE = 'mofang://h5close'
export const APP_PATH_BACK = 'mofang://h5back'
